import { FrameWithStickyTitle } from 'components/BrandSlides/BrandSlides.jsx';
import { ensureArray, safeMap, safeGetProp, ensureString } from 'utils/safeArray';

export default function Horizon({ title, subtitle, phases, accent_color }) {
  const safePhases = ensureArray(phases);
  
  return (
    <FrameWithStickyTitle title={title} subtitle={subtitle} accentColor={accent_color}>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {safeMap(safePhases, (phase, i) => (
          <div key={i} className="flex flex-col items-center text-center">
            <h3 className="text-xl font-semibold mb-2">{ensureString(safeGetProp(phase, 'name'))}</h3>
            <p className="text-base text-gray-600">{ensureString(safeGetProp(phase, 'description'))}</p>
          </div>
        ))}
      </div>
    </FrameWithStickyTitle>
  );
}
